export const accessHero = {
  title: 'アクセス',
  titleEn: 'ACCESS',
  lead: '本校は東京・お台場（江東区青海）にあります。ご来訪は完全予約制です。',
};

export const locationInfo = [
  { label: '名称', value: '日本執事アカデミー（運営: 一般社団法人全日本執事協会）' },
  { label: '住所', value: '〒135-0064 東京都江東区青海2丁目7-4' },
  { label: '電話', value: '03-6824-4086', note: '受付 平日10:00〜17:00', link: 'tel:0368244086' },
  { label: 'メール', value: 'info@butler-academy.jp', link: 'mailto:info@butler-academy.jp' },
  { label: '来訪', value: '完全予約制' },
];

export const trainAccessStations = [
  {
    name: '東京国際クルーズターミナル駅',
    line: 'ゆりかもめ',
    time: '徒歩約5分',
    directions:
      '駅を出て青海方面へ直進、信号を渡り二つ目の角を右折してください。ガラス張りの建物が見えてまいります。',
  },
  {
    name: 'テレコムセンター駅',
    line: 'ゆりかもめ',
    time: '徒歩約5分',
    directions:
      '駅西口を出て左方向へ進み、大きな交差点を渡ってから青海遊歩道沿いにお進みください。約400m先の左手に校舎がございます。',
  },
];

export const accessFaqs = [
  {
    question: '最寄り駅はどこですか？',
    answer:
      'ゆりかもめ「東京国際クルーズターミナル駅」と「テレコムセンター駅」で、いずれも徒歩約5分です。',
  },
  {
    question: '予約なしで訪問できますか？',
    answer:
      'ご来訪は完全予約制です。お問い合わせフォーム・お電話（平日10:00〜17:00）・メールのいずれかで事前にご予約ください。',
  },
  {
    question: '駐車場はありますか？',
    answer:
      '公共交通機関でのご来校をお勧めしています。お車でお越しの場合は事前にご相談ください。',
  },
];

export const accessRelatedPages = [
  {
    title: '施設・設備紹介',
    description: 'お台場の本校と実習環境',
    href: '/facilities',
  },
  {
    title: '個別相談予約',
    description: 'オンライン可・無料の個別相談',
    href: '/consultation',
  },
  {
    title: '体験講座',
    description: '1日で執事の所作を体験',
    href: '/seminar',
  },
  {
    title: 'お問い合わせ',
    description: 'ご質問・ご相談の窓口',
    href: '/contact',
  },
];